import { useEffect, useState } from 'react'
import { gqlFetchList } from 'app/lib/graphqlClient'
import { useUser } from 'app/utils'
import { activitiesExclusionTerm } from 'lib/activitiesExclusion'
import { bg } from 'lib/background'
import { type ListTemplate, templateSearch } from 'lib/listTemplates'

/** How many records each template would list today. Missing until answered; a failed read stays missing. */
export function useTemplateCounts(templates: ReadonlyArray<ListTemplate>): Record<string, number | undefined> {
  const [counts, setCounts] = useState<Record<string, number | undefined>>({})
  const user = useUser()
  const activitiesBase = activitiesExclusionTerm(user)

  useEffect(() => {
    let cancelled = false
    for (const template of templates) {
      bg(
        gqlFetchList(
          template.recordType,
          { search: templateSearch(template, activitiesBase), pagination: { limit: 0 } },
          `id`,
          { suppressErrorToast: true },
        )
          .then((result) => {
            if (!cancelled) setCounts((prev) => ({ ...prev, [template.id]: result.total }))
          })
          .catch(() => undefined),
      )
    }
    return () => {
      cancelled = true
    }
  }, [templates, activitiesBase])

  return counts
}
